import React from "react";

import ActionButtons from "components/basic/action-buttons/ActionButtons";
import DataTable from "components/basic/data-table/DataTable";
import { TableColumn } from "components/pages/measurement-devices/utils/types";
import { T } from "services/lang/LanguageService";
import { DatasetsSearchResult } from "types/types";

type TaskResult = Omit<DatasetsSearchResult, "dashboard">

type TaskResultTableProps = {
  results: TaskResult[];
  loading?: boolean;
};

const TaskResultTable: React.FC<TaskResultTableProps> = ({ results, loading }) => {
  
  const renderLink = (rowData: TaskResult) => (
    <ActionButtons
      urlOnLink={`/airflow/${rowData.task.id.dagId}/${rowData.task.id.taskId}`}
      urlTarget="_blank"
    />
  );
  

  const dashboardColumns: TableColumn<TaskResult>[] = [
    {
      field: "task.dagTitle",
      header: `DAG ${T("word.title").toLowerCase()}`,
      columnKey: "dagTitle",
    },
    {
      field: "task.title",
      header: T("word.task-title"),
      columnKey: "taskTitle",
    },
    {
      field: "task.description",
      header: T("word.task-description"),
      columnKey: "taskDescription",
      style: { maxWidth: "30rem", wordBreak: "break-word" },
    },
    {
      header: "Link",
      columnKey: T("word.link"),
      body: renderLink,
    },
  ];


  return (
    <DataTable
    data={results}
    columns={dashboardColumns}
    tableConfig={{ loading }}
  />
  )
}

export default TaskResultTable;